@if (!isUpdateVehicleDetailsInfo) {
<div [ngClass]="inlineComponent ? 'inline-dialog-container' : 'dialog-container'" class="relative">
  @if(!inlineComponent){
  <div class="header-section">
    <div class="w-full flex justify-center flex-col items-center">
      <p class="font-bold text-2xl leading-9 text-[#010B18] m-0">Live Vehicle Data</p>
      <p class="font-normal text-sm leading-5 text-[#515765] m-2">Powered by</p>
      <img class="h-10 w-[180px] mt-2" src="assets/images/zero-mx-data.svg" />
    </div>
  </div>
  <div class="absolute top-[42px] right-[44px]">
    <button type="button" class="close add-close-button h-8 w-8" data-dismiss="modal" (click)="closedialog()">
      <span style="font-size: 32px; font-weight: 500; color: #b1acb0" class="material-icons icons-close-mobile">close</span>
    </button>
  </div>
  }
  <div class="main-frame pt-2">
    <!-- START: Options Vehicle License Plate && Vehicle Details -->
    @if (!isVehicleDetails && !isVehicleLicensePlate && false) {
    <div class="flex-center gap-4 flex-col">
      <div class="text-base font-semibold leading-9 color-[#515765] flex-center">Select one of the following options</div>
      <div class="flex gap-6">
        <div class="border border-solid border-[#53565B38] p-5 rounded-xl flex fl-col gap-4 w-1/2">
          <div class="h-[100px] bg-[#EBF0FA] rounded-lg w-full flex-center">
            <div><img class="h-[31px] w-[92px]" src="assets/images/motor-vehicle-xyz000.svg" /></div>
          </div>
          <div class="flex fl-col gap-3 flex-center txt-center">
            <div class="text-base font-semibold text-[#515765]">Vehicle <Span class="font-bold text-[#25508E]"> License Plate</Span></div>
            <div class="text-xs font-normal text-[#515765]">Get vehicle data by providing the License Plate number (most accurate)</div>
          </div>
          <div class="w-full">
            <button type="button" class="py-2 px-4 bg-[#25508E] rounded w-full h-[38px] flex-center" (click)="isVehicleLicensePlate = true">
              <span class="font-semibold text-sm text-[#FFFFFF]">Continue</span>
            </button>
          </div>
        </div>
        <div class="border border-solid border-[#53565B38] p-5 rounded-xl flex fl-col gap-4 w-1/2">
          <div class="h-[100px] bg-[#EBF0FA] rounded-lg w-full flex-center">
            <div><img class="h-[31px] w-[92px]" src="assets/images/motor-vehicle-basic.svg" /></div>
          </div>
          <div class="flex fl-col gap-3 flex-center txt-center">
            <div class="text-base font-bold text-[#25508E]">Basic Vehicle Details</div>
            <div class="text-xs font-normal text-[#515765]">Get vehicle data by providing the year, make, model, trim & condition.</div>
          </div>
          <div class="w-full">
            <button type="button" class="py-2 px-4 bg-[#25508E] rounded w-full h-[38px] flex-center" (click)="isVehicleDetails = true">
              <span class="font-semibold text-sm text-[#FFFFFF]">Continue</span>
            </button>
          </div>
        </div>
      </div>
    </div>
    }
    <!-- START: Vehicle License Plate -->
    <!-- START: Vehicle Details -->
    @if ((isVehicleDetails || true) && !is_loading) {
    <div>
      <add-vehicle-basic-details-info
        [templateId]="data?.templateId"
        [inlineComponent]="inlineComponent"
        (updateVehicleDetailsInfo)="onupdateVehicleDetailsInfo($event)"
        [currentFormId]="currentFormId"
        [dialogRef]="dialogRef"
        [apiMotorValueList]="data.apiMotorValueList"
        (updateStepNumber)="updateStepNumber($event)"
        [stepNumber]="stepNumber"
      ></add-vehicle-basic-details-info>
    </div>
    }
  </div>
  <!-- <div  *ngIf="isFetchingData" style="border: 1px solid rgba(211, 220, 232, 0.7);" class="h-60  text-center rounded p-3 document-container">
        <img  class="mt-8" src="assets/images/fetch-vehicle.svg" />
        <p class="font-semibold text-base text-[#53565B]" >One moment while we get data for this Vehicle
        </p>
      </div>
      <form [formGroup]="vehicleForm" *ngIf="!isFetchingData" style="border: 1px solid rgba(211, 220, 232, 0.7);" class="rounded p-3 document-container">
        <div       style="display: flex;justify-content: space-between;">
          <p class="font-semibold text-base text-[#53565B]" >Vehicle details</p>
          <p *ngIf="!is_active_connection" style="line-height: 24px !important;padding: 0 6px;"  class="font-bold text-xs text-[#DEA000] rounded bg-[#FFF2CD]" >No active connection</p>
          <p *ngIf="is_active_connection" style="line-height: 24px !important;padding: 0 6px;" class="font-bold text-xs text-[#1AA140] rounded bg-[#DAF4F2]">Active Connection</p>
        </div>
        <div
      style="display: flex;
      justify-content: space-between;
      padding: 0px;
      margin-left: 16px;
      flex-wrap: wrap;
      margin-right: 16px;"
          class="flex-container mobile-form-container margin-top-custom"
          >
          <div
            class="dynamic-form-field-container" style="width: 33%;">
            <div>
              <mat-form-field
                appearance="fill"
                floatLabel="auto"
                style="width: 100% !important"
                class="automtic-form-desing-form-only"
                >
                <mat-label class="automtic-form-desing-lable">
                  Year
                </mat-label>
                <mat-select
                  class="example-panel-select"
                  matNativeControl
                  (ngModelChange)="onValueChange($event)"
                  disableOptionCentering
                  formControlName="year"
                  >
                  <mat-option [value]="item?.value" *ngFor="let item of yearList">
                    {{ item?.label }}
                  </mat-option>
                </mat-select>
              </mat-form-field>
            </div>
          </div>
          <div
            class="dynamic-form-field-container" style="width: 33%;">
            <mat-form-field
              floatLabel="auto"
              appearance="fill"
              style="width: 100% !important"
              class="automtic-form-desing-form-only"
              >
              <mat-label class="automtic-form-desing-lable">
                Make
              </mat-label>
              <input
                matInput
                placeholder="Ex. Volvo"
                formControlName="make"
                (ngModelChange)="onValueChange($event)"
                type="text"
                />
              </mat-form-field>
            </div>
            <div
              class="dynamic-form-field-container" style="width: 33%;">
              <mat-form-field
                floatLabel="auto"
                appearance="fill"
                style="width: 100% !important"
                class="automtic-form-desing-form-only"
                >
                <mat-label class="automtic-form-desing-lable">
                  Model
                </mat-label>
                <input
                  matInput
                  formControlName="model"
                  (ngModelChange)="onValueChange($event)"
                  placeholder="Ex. XC 90"
                  type="text"
                  />
                </mat-form-field>
              </div>
              <div
                class="dynamic-form-field-container" style="width: 100%;margin: 0 16px;">
                <mat-form-field
                  appearance="fill"
                  floatLabel="auto"
                  style="width: -webkit-fill-available !important; margin: 0 -32px !important;"
                  class="automtic-form-desing-form-only"
                  >
                  <mat-label class="automtic-form-desing-lable">
                    Condition
                  </mat-label>
                  <mat-select
                    class="example-panel-select"
                    matNativeControl
                    formControlName="condition"
                    disableOptionCentering
                    >
                    <mat-option [value]="item?.value" *ngFor="let item of conditionList">
                      {{ item?.label }}
                    </mat-option>
                  </mat-select>
                </mat-form-field>
                <mat-form-field
                  appearance="fill"
                  floatLabel="auto"
                  style="width: -webkit-fill-available !important; margin: 0 -32px !important;"
                  class="automtic-form-desing-form-only"
                  >
                  <mat-label class="automtic-form-desing-lable">
                    Value Estimate Type
                  </mat-label>
                  <mat-select
                    class="example-panel-select"
                    matNativeControl
                    formControlName="type"
                    disableOptionCentering
                    >
                    <mat-option [value]="item?.value" *ngFor="let item of ValueEstimateTypeList">
                      {{ item?.label }}
                    </mat-option>
                  </mat-select>
                </mat-form-field>
                <mat-form-field
                  appearance="fill"
                  *ngIf="isFetchedData"
                  floatLabel="auto"
                  style="width: -webkit-fill-available !important; margin: 0 -32px !important;"
                  class="automtic-form-desing-form-only"
                  >
                  <mat-label class="automtic-form-desing-lable">
                    Select Trim
                  </mat-label>
                  <mat-select
                    class="example-panel-select"
                    matNativeControl
                    formControlName="trim"
                    disableOptionCentering
                    >
                    <mat-option [value]="item?.value" *ngFor="let item of trimList">
                      {{ item?.label }}
                    </mat-option>
                  </mat-select>
                </mat-form-field>
              </div>
              <div class="dynamic-form-field-container" style="width: 100%;margin: 0 16px;">
                <button
                  [ngClass]="(isFetchedData ? false : (!(vehicleForm.controls.year.valid && vehicleForm.controls.make.valid && vehicleForm.controls.model.valid))) ? 'disable-btn' : 'enable-btn'"
                  (click)="fetchSave()"
                  class="h-8 rounded  "  style="width: -webkit-fill-available;margin: 0 -32px;" >
                  {{!isFetchedData ? 'Connect': 'Update Vehicle Details'}}
                </button>
              </div>
            </div>
          </form> -->
  @if(inlineComponent){
  <div class="bottom-8 border-t border-solid border-[#C1C2C5]">
    <!-- @if (data.is_edit || ( stepNumber === 1 || inlineComponent)) {
    <div>
      @if (!inlineComponent) {
      <form class="mt-6">
        <mat-slide-toggle class="margin-zero mb-0 mt-0" (change)="onChange()" [checked]="markOwnerAsComplete">
          Mark this attribute complete
        </mat-slide-toggle>
      </form>
      }
    </div>
    }  -->
    @if (!data.is_edit && stepNumber === 2 && !inlineComponent) {
    <div (click)="backArrow()">
      <div class="flex mt-6 pointer px-4 py-2.5">
        <mat-icon class="h-4 w-4 text-[#18191C] text-sm">arrow_back</mat-icon>
        <!-- <img src="assets/images/arraw-back.svg" /> -->
        <span class="text-sm font-semibold text-[#18191C] ml-2">Back</span>
      </div>
    </div>
    }
  </div>
  }@else{
  <div class="absolute right-[60px] left-[60px] bottom-8 ">
    <!-- @if (data.is_edit || ( stepNumber === 1 || inlineComponent)) {
    <div class="action">
      <form class="mt-6">
        <mat-slide-toggle class="margin-zero mb-0 mt-0" (change)="onChange()" [checked]="markOwnerAsComplete">
          Mark this attribute complete
        </mat-slide-toggle>
      </form>
    </div>
    } -->
    @if (!data.is_edit && stepNumber === 2 && !inlineComponent) {
    <div (click)="backArrow()">
      <div class="flex mt-6 pointer px-4 py-2.5">
        <mat-icon class="h-4 w-4 text-[#18191C] text-sm">arrow_back</mat-icon>
        <!-- <img src="assets/images/arraw-back.svg" /> -->
        <span class="text-sm font-semibold text-[#18191C] ml-2">Back</span>
      </div>
    </div>
    }
  </div>
  }
</div>
} @if (isUpdateVehicleDetailsInfo) {
<div class="replace-existing-dialog-container relative">
  <div class="flex fl-col gap-5">
    <div class="flex-center gap-3">
      <div class="flex-center h-9 w-9 bg-[#25508E] rounded"><mat-icon class="text-xl text-[#FFFFFF] flex-center h-5 w-5">info</mat-icon></div>
      <div class="text-[#000000] text-sm font-bold">Replace existing connection</div>
    </div>
    <div class="text-sm text-[#000000] font-normal">Are you sure you want to remove the current information on this form?</div>
    <div class="text-xs w-full flex gap-4 fl-justify-end mt-2">
      <button
        class="w-[90px] py-[7px] px-[12px] bg-[#FFFFFF] text-[#707070] font-semibold border border-[#D3DCE8] rounded flex-center"
        (click)="onReplaceConnection(false)"
      >
        No
      </button>
      <button
        class="w-[90px] py-[7px] px-[12px] bg-[#25508E] text-[#FFFFFF] font-semibold border border-[#25508E] rounded flex-center"
        (click)="onReplaceConnection(true)"
      >
        Yes
      </button>
    </div>
  </div>
</div>
}
